import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import NotFoundPage from '@/pages/NotFoundPage';
import LoginPage from '@/pages/LoginPage';
import VerifyAuthCodePage from '@/pages/VerifyAuthCodePage';
import SignupSummaryPage from '@/pages/SignupSummaryPage.vue';
import ForgottenPasswordPage from '@/pages/ForgottenPassword/ForgottenPasswordPage.vue';
import ForgottenPasswordConfirmPage from '@/pages/ForgottenPassword/ForgottenPasswordConfirmPage.vue';
import ResetPasswordPage from '@/pages/ForgottenPassword/ResetPasswordPage.vue';
import ResetPasswordConfirmPage from '@/pages/ForgottenPassword/ResetPasswordConfirmPage.vue';
import SignupPage from '@/pages/SignupPage';

Vue.use(Router);

/*
Available routes meta:
- ignore: If true, the URL will not be accessible directly (used for children)
- title: If set, will be used as the page <title>
*/

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: LoginPage,
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignupPage,
      beforeEnter: async (to, from, next) => {
        if (to.query.email) {
          await store.dispatch('auth/forceEmail', { email: to.query.email });
        }

        next();
      },
    },
    {
      path: '/signed-up',
      name: 'signup-summary',
      component: SignupSummaryPage,
    },
    {
      path: '/forgotten-password',
      name: 'forgotten-password',
      component: ForgottenPasswordPage,
    },
    {
      path: '/forgotten-password/confirm',
      name: 'forgotten-password-confirm',
      component: ForgottenPasswordConfirmPage,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPasswordPage,
      beforeEnter: (to, from, next) => !to.query.token ? next({ name: 'forgotten-password' }) : next(),
      props: (route) => ({ token: route.query.token }),
    },
    {
      path: '/reset-password/confirm',
      name: 'reset-password-confirm',
      component: ResetPasswordConfirmPage,
    },
    {
      path: '/verify-auth-code',
      name: 'verify-auth-code',
      component: VerifyAuthCodePage,
      beforeEnter: (to, from, next) => !store.getters['auth/hasCredentials'] ? next({ name: 'login' }) : next(),
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFoundPage,
      meta: { title: 'Erreur - Page inexistante' },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.ignore) {
    return next(false);
  }

  await store.dispatch('appNotification/redirected');

  if (to.meta.title) {
    document.title = `${to.meta.title} - Hellocare, votre solution de télémédecine`;
  } else {
    document.title = 'Hellocare - Votre solution de télémédecine';
  }

  return next();
});

export default router;
